import { proxiedUrlFor } from "./media-url-utils";

const setFluentFonts = () => {
  const style = document.createElement("style");

  // Define the font-face CSS rules
  style.innerHTML = `
    @font-face {
        font-family: "Segoe UI";
        src: url('${proxiedUrlFor(
          "https://res-1.cdn.office.net/files/fabric-cdn-prod_20221209.001/assets/fonts/segoeui-westeuropean/segoeui-regular.woff2"
        )}') format('woff2');
        font-weight: 400;
    }
    @font-face {
        font-family: "Segoe UI";
        src: url('${proxiedUrlFor(
          "https://res-1.cdn.office.net/files/fabric-cdn-prod_20221209.001/assets/fonts/segoeui-westeuropean/segoeui-semibold.woff2"
        )}') format('woff2');
        font-weight: 600;
    }
    @font-face {
        font-family: "Segoe UI";
        src: url('${proxiedUrlFor(
          "https://res-1.cdn.office.net/files/fabric-cdn-prod_20221209.001/assets/fonts/segoeui-westeuropean/segoeui-bold.woff2"
        )}') format('woff2');
        font-weight: 700;
    }
    `;

  // Append the style element to the document head
  document.head.appendChild(style);
};

setFluentFonts();
